<div class="container-fluid mt-4">
  <div class="card bg-white border-0 shadow-sm">
    <div class="card-body">
      <div class="row align-items-start">
        <div class="col-12 col-lg-4 mb-3">
          <p class="fw-bold mb-0">Fuel Supplier</p>
          <div class="d-flex bg-light p-3 border">
            <div *ngIf="supplier.supplier.logo" class="flex-shrink-0 avatar avatar-68 bg-white rounded shadow">
              <img src="{{ supplier.supplier.logo }}" alt="{{ supplier.supplier.name }}">
            </div>
            <div *ngIf="!supplier.supplier.logo" class="flex-shrink-0 avatar avatar-68 bg-white rounded p-3 shadow">
              <svg fill="#c6c9d2" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 60 60" xml:space="preserve" stroke="#c6c9d2">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <g>
                    <path
                      d="M58,37.104V4c0-0.553-0.448-1-1-1H1C0.448,3,0,3.447,0,4v44c0,0.553,0.448,1,1,1h34.003c1.963,4.693,6.6,8,11.997,8 c7.168,0,13-5.832,13-13C60,41.465,59.26,39.105,58,37.104z M34.359,47H2V5h54v29.622c-0.17-0.164-0.354-0.311-0.532-0.465 c-0.088-0.075-0.171-0.155-0.261-0.228c-0.235-0.192-0.48-0.37-0.728-0.545c-0.092-0.065-0.181-0.135-0.275-0.198 c-0.245-0.163-0.498-0.312-0.754-0.458c-0.109-0.063-0.214-0.13-0.325-0.189c-0.077-0.041-0.154-0.083-0.232-0.123 c0.179-0.385,0.112-0.852-0.218-1.154l-12-11c-0.196-0.179-0.452-0.277-0.72-0.262c-0.265,0.012-0.515,0.129-0.694,0.325 l-9.794,10.727l-4.743-4.743c-0.374-0.373-0.972-0.391-1.368-0.044L6.339,41.249c-0.415,0.365-0.455,0.997-0.09,1.412 C6.447,42.886,6.723,43,7,43c0.234,0,0.47-0.082,0.66-0.249l16.313-14.362l10.302,10.301c0.203,0.203,0.47,0.295,0.736,0.287 C34.361,40.523,34,42.22,34,44c0,0.493,0.033,0.977,0.087,1.456c0.009,0.075,0.024,0.149,0.034,0.224 c0.056,0.428,0.131,0.849,0.227,1.262C34.353,46.961,34.354,46.981,34.359,47z M48.779,31.136 c-0.162-0.022-0.321-0.055-0.485-0.071C47.867,31.023,47.435,31,47,31c-4.773,0-8.942,2.593-11.203,6.437 c-0.036-0.054-0.06-0.114-0.107-0.162l-4.807-4.807l9.181-10.054l9.694,8.887c-0.067-0.015-0.133-0.032-0.2-0.045 C49.301,31.204,49.039,31.172,48.779,31.136z M47,55c-4.787,0-8.859-3.08-10.367-7.358c-0.094-0.267-0.176-0.536-0.249-0.806 c-0.015-0.058-0.03-0.115-0.045-0.173c-0.06-0.238-0.112-0.476-0.156-0.716c-0.024-0.133-0.042-0.267-0.061-0.401 c-0.026-0.18-0.054-0.36-0.071-0.54C36.021,44.674,36,44.339,36,44c0-6.065,4.935-11,11-11c0.426,0,0.848,0.031,1.265,0.079 c0.127,0.015,0.25,0.039,0.375,0.057c0.291,0.044,0.579,0.096,0.863,0.162c0.141,0.033,0.281,0.07,0.421,0.108 c0.268,0.074,0.531,0.159,0.792,0.253c0.134,0.048,0.269,0.094,0.4,0.147c0.295,0.119,0.583,0.255,0.866,0.399 c0.083,0.042,0.17,0.077,0.252,0.121c0.342,0.185,0.671,0.393,0.992,0.614c0.131,0.09,0.255,0.19,0.382,0.286 c0.199,0.15,0.395,0.305,0.584,0.469c0.127,0.11,0.251,0.224,0.373,0.339c0.193,0.184,0.379,0.377,0.559,0.575 c0.094,0.103,0.191,0.202,0.281,0.309c0.261,0.311,0.51,0.634,0.739,0.976C57.315,39.643,58,41.743,58,44 C58,50.065,53.065,55,47,55z">
                    </path>
                    <path
                      d="M51.95,39.051c-0.391-0.391-1.023-0.391-1.414,0L47,42.586l-3.536-3.535c-0.391-0.391-1.023-0.391-1.414,0 s-0.391,1.023,0,1.414L45.586,44l-3.536,3.535c-0.391,0.391-0.391,1.023,0,1.414c0.195,0.195,0.451,0.293,0.707,0.293 s0.512-0.098,0.707-0.293L47,45.414l3.536,3.535c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293 c0.391-0.391,0.391-1.023,0-1.414L48.414,44l3.536-3.535C52.34,40.074,52.34,39.441,51.95,39.051z">
                    </path>
                    <path
                      d="M16,25.138c3.071,0,5.569-2.498,5.569-5.568C21.569,16.498,19.071,14,16,14s-5.569,2.498-5.569,5.569 C10.431,22.64,12.929,25.138,16,25.138z M16,16c1.968,0,3.569,1.602,3.569,3.569S17.968,23.138,16,23.138s-3.569-1.601-3.569-3.568 S14.032,16,16,16z">
                    </path>
                  </g>
                </g>
              </svg>
            </div>
            <div class="flex-grow-1 ms-3">
              <p class="fw-bold mb-0">{{ supplier.supplier.name }} <span *ngIf="supplier.supplier.supplierAlias"
                  class="text-muted">({{supplier.supplier.supplierAlias}})</span></p>
              <address class="mb-0">
                <ng-container *ngIf="supplier.supplier.address">{{ supplier.supplier.address }},<br></ng-container>
                <ng-container *ngIf="supplier.supplier.city">{{ supplier.supplier.city }}, </ng-container>
                <ng-container *ngIf="supplier.supplier.country.name">{{ supplier.supplier.country.name
                  }}</ng-container>
              </address>
            </div>
          </div>
        </div>

        <div class="col-lg-8">
          <p class="fw-bold mb-0">Fuel Supply Team</p>
          <div class="row">
            <div class="col-12 col-lg-6 col-xxl-6" *ngFor="let user of supplier.supplier.users; let index = index;">
              <div class="d-flex bg-light p-3 border">
                <div *ngIf="user.logo" class="flex-shrink-0 avatar avatar-68 bg-white rounded shadow">
                  <img src="{{ user.logo }}" alt="{{ user.lastName }}">
                </div>
                <div *ngIf="!user.logo" class="flex-shrink-0 avatar avatar-68 bg-white rounded p-3 shadow">
                  <svg fill="#c6c9d2" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 60 60" xml:space="preserve"
                    stroke="#c6c9d2">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                      <g>
                        <path
                          d="M58,37.104V4c0-0.553-0.448-1-1-1H1C0.448,3,0,3.447,0,4v44c0,0.553,0.448,1,1,1h34.003c1.963,4.693,6.6,8,11.997,8 c7.168,0,13-5.832,13-13C60,41.465,59.26,39.105,58,37.104z M34.359,47H2V5h54v29.622c-0.17-0.164-0.354-0.311-0.532-0.465 c-0.088-0.075-0.171-0.155-0.261-0.228c-0.235-0.192-0.48-0.37-0.728-0.545c-0.092-0.065-0.181-0.135-0.275-0.198 c-0.245-0.163-0.498-0.312-0.754-0.458c-0.109-0.063-0.214-0.13-0.325-0.189c-0.077-0.041-0.154-0.083-0.232-0.123 c0.179-0.385,0.112-0.852-0.218-1.154l-12-11c-0.196-0.179-0.452-0.277-0.72-0.262c-0.265,0.012-0.515,0.129-0.694,0.325 l-9.794,10.727l-4.743-4.743c-0.374-0.373-0.972-0.391-1.368-0.044L6.339,41.249c-0.415,0.365-0.455,0.997-0.09,1.412 C6.447,42.886,6.723,43,7,43c0.234,0,0.47-0.082,0.66-0.249l16.313-14.362l10.302,10.301c0.203,0.203,0.47,0.295,0.736,0.287 C34.361,40.523,34,42.22,34,44c0,0.493,0.033,0.977,0.087,1.456c0.009,0.075,0.024,0.149,0.034,0.224 c0.056,0.428,0.131,0.849,0.227,1.262C34.353,46.961,34.354,46.981,34.359,47z M48.779,31.136 c-0.162-0.022-0.321-0.055-0.485-0.071C47.867,31.023,47.435,31,47,31c-4.773,0-8.942,2.593-11.203,6.437 c-0.036-0.054-0.06-0.114-0.107-0.162l-4.807-4.807l9.181-10.054l9.694,8.887c-0.067-0.015-0.133-0.032-0.2-0.045 C49.301,31.204,49.039,31.172,48.779,31.136z M47,55c-4.787,0-8.859-3.08-10.367-7.358c-0.094-0.267-0.176-0.536-0.249-0.806 c-0.015-0.058-0.03-0.115-0.045-0.173c-0.06-0.238-0.112-0.476-0.156-0.716c-0.024-0.133-0.042-0.267-0.061-0.401 c-0.026-0.18-0.054-0.36-0.071-0.54C36.021,44.674,36,44.339,36,44c0-6.065,4.935-11,11-11c0.426,0,0.848,0.031,1.265,0.079 c0.127,0.015,0.25,0.039,0.375,0.057c0.291,0.044,0.579,0.096,0.863,0.162c0.141,0.033,0.281,0.07,0.421,0.108 c0.268,0.074,0.531,0.159,0.792,0.253c0.134,0.048,0.269,0.094,0.4,0.147c0.295,0.119,0.583,0.255,0.866,0.399 c0.083,0.042,0.17,0.077,0.252,0.121c0.342,0.185,0.671,0.393,0.992,0.614c0.131,0.09,0.255,0.19,0.382,0.286 c0.199,0.15,0.395,0.305,0.584,0.469c0.127,0.11,0.251,0.224,0.373,0.339c0.193,0.184,0.379,0.377,0.559,0.575 c0.094,0.103,0.191,0.202,0.281,0.309c0.261,0.311,0.51,0.634,0.739,0.976C57.315,39.643,58,41.743,58,44 C58,50.065,53.065,55,47,55z">
                        </path>
                        <path
                          d="M51.95,39.051c-0.391-0.391-1.023-0.391-1.414,0L47,42.586l-3.536-3.535c-0.391-0.391-1.023-0.391-1.414,0 s-0.391,1.023,0,1.414L45.586,44l-3.536,3.535c-0.391,0.391-0.391,1.023,0,1.414c0.195,0.195,0.451,0.293,0.707,0.293 s0.512-0.098,0.707-0.293L47,45.414l3.536,3.535c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293 c0.391-0.391,0.391-1.023,0-1.414L48.414,44l3.536-3.535C52.34,40.074,52.34,39.441,51.95,39.051z">
                        </path>
                        <path
                          d="M16,25.138c3.071,0,5.569-2.498,5.569-5.568C21.569,16.498,19.071,14,16,14s-5.569,2.498-5.569,5.569 C10.431,22.64,12.929,25.138,16,25.138z M16,16c1.968,0,3.569,1.602,3.569,3.569S17.968,23.138,16,23.138s-3.569-1.601-3.569-3.568 S14.032,16,16,16z">
                        </path>
                      </g>
                    </g>
                  </svg>
                </div>
                <div class="flex-grow-1 ms-3">
                  <p class="fw-bold mb-0">{{ user.firstName }} {{ user.lastName }}</p>
                  <ng-container *ngIf="user.title">{{ user.title }}<br></ng-container>
                  <a href="mailto:{{ user.email }}">{{ user.email }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mt-4">
  <div class="row">
    <div class="col-12 col-lg-8">

      <!-- Status & Actions Card -->
      <div class="card card-custom mb-4" *ngIf="supplier">
        <div class="card-header bg-white d-flex align-items-center justify-content-between py-3">
          <div class="d-flex align-items-center">
            <h4 class="mb-0 me-3">Bid Status</h4>
            <jft-round-status [status]="round.status"></jft-round-status>
          </div>
          <jft-time-remaining [round]="round"></jft-time-remaining>
        </div>
        <div class="card-body">
          <div class="row align-items-center">
            <div class="col-md-6 border-end">
              <div class="d-flex align-items-center mb-2">
                <span class="text-muted small text-uppercase fw-bold me-2">Current Status:</span>
                <jft-offer-status [signature]="$safeNavigationMigration(supplier.bid?.signature)" [status]="supplier.status"
                  [awardedPercent]="supplier.awardedPercent">
                </jft-offer-status>
              </div>
              <div class="mb-2" *ngIf="supplier.awardComment">
                <span class="text-muted small text-uppercase fw-bold d-block mb-1">
                  Award Comment
                  <span class="badge bg-warning-subtle text-dark border border-warning-subtle ms-1 fw-normal text-none">
                    Visible to the supplier
                  </span>
                </span>
                <jft-read-more-modal title="Award Comment" [text]="supplier.awardComment"></jft-read-more-modal>
              </div>
              <div class="d-flex align-items-center"
                *ngIf="supplier.bid && supplier.status == offerStatuses.RECEIVED && user.canManage(tender)">
                <jft-bid-edit-modal [tender]="tender" [contract]="contract" [offer]="supplier"
                  (onUpdated)="onUpdatedBidModal($event, supplier)"></jft-bid-edit-modal>
              </div>
            </div>
            <div class="col-md-6 ps-md-4">
              <div class="d-flex align-items-center justify-content-end"
                *ngIf="supplier.status == offerStatuses.RECEIVED && user.canManage(tender)">
                <jft-award-button *ngIf="round.status !== roundStatuses.AWARDED" [offer]="supplier"
                  [contract]="contract" [loadingAward]="loadingAward" (onAward)="award($event)">
                </jft-award-button>
                <span *ngIf="!round.isClosed && user.canManage(tender)" class="ms-2">
                  <jft-decline-offer-button [offer]="supplier" [loading]="loadingDecline"
                    (onDecline)="declineOffer($event)">
                  </jft-decline-offer-button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Pricing & Market Data Card -->
      <div class="card card-custom mb-4"
        *ngIf="[offerStatuses.RECEIVED, offerStatuses.AWARDED, offerStatuses.DECLINED_SUBMITTED].includes(supplier.status)">
        <div class="card-header bg-light py-3">
          <h5 class="mb-0">Pricing & Market Data</h5>
        </div>
        <div class="card-body p-0">
          <!-- Price Base -->
          <div class="row g-0 border-bottom align-items-start"
            *ngIf="fieldConfigs['bid_index_code'] || fieldConfigs['bid_market_price_value']">
            <div class="col-lg-5 p-3 bg-light-blue fw-medium">
              Price Base
              <div *ngIf="user.company?.settings?.platts_username" ngbDropdown class="d-inline-block float-end">
                <jft-index-date-range [dateRange]="" [placeholder]="'Select Date Range'"
                  [class]="'form-control form-control-sm me-2'" (onDates)="onDateRange($event)"></jft-index-date-range>
              </div>
            </div>
            <div class="col-lg-7 p-3">
              <!-- Index-based pricing -->
              <ng-container *ngIf="supplier.bid.index?.index_code">
                <div class="mb-2" *ngIf="supplier.bid.index.index_code.provider">
                  <span class="text-muted small d-block">Index Provider:</span>
                  <span class="text-capitalize">{{ supplier.bid.index.index_code.provider }}</span>
                </div>
                <div class="mb-2">
                  <span class="text-muted small d-block">Index Code:</span>
                  <strong>{{ supplier.bid.index.index_code.code }}</strong>
                  <span *ngIf="supplier.bid.index.bate"> - {{ supplier.bid.index.bate.name }}</span>
                </div>
                <div class="mb-2" *ngIf="supplier.bid.index.averaging_method">
                  <span class="text-muted small d-block">Index Averaging:</span>
                  <span>{{ supplier.bid.index.averaging_method.name }}</span>
                </div>
                <div class="mb-2" *ngIf="supplier.bid.index.averaging_offset">
                  <span class="text-muted small d-block">Index Averaging Offset:</span>
                  <span>{{ supplier.bid.index.averaging_offset.name }}</span>
                </div>
                <div *ngIf="supplier.bid.index.effective_day">
                  <span class="text-muted small d-block">Price Effective Day:</span>
                  <span>{{ supplier.bid.index.effective_day.name }}</span>
                </div>
              </ng-container>
              <!-- Legacy plattsIndexPrice -->
              <span *ngIf="supplier.bid.plattsIndexPrice?.index && !supplier.bid.index?.index_code">
                <strong>{{ supplier.bid.plattsIndexPrice.index.code }}</strong>
                ({{ supplier.bid.plattsIndexPrice.bates.name }})
              </span>
              <!-- Market Price -->
              <span
                *ngIf="supplier.bid.marketPrice && !supplier.bid.index?.index_code && !supplier.bid.plattsIndexPrice?.index"
                class="fw-bold">
                {{ $safeNavigationMigration(supplier.bid.marketPrice.price['price']?.value) | number:'1.2-4' }}
                {{ supplier.bid.marketPrice.price['price']?.currency?.code }} /
                {{ supplier.bid.marketPrice.price['units']?.code }}
              </span>
              <!-- No pricing -->
              <span
                *ngIf="!supplier.bid.index?.index_code && !supplier.bid.plattsIndexPrice?.index && !supplier.bid.marketPrice"
                class="text-muted small italic">None</span>
              <span class="ms-2 fw-bold" *ngIf="supplier.bid.plattsIndexPrice?.value">
                ({{ supplier.bid.plattsIndexPrice.value | number:'1.2-4' }} {{ baseCurrency.code }} / {{ baseUnit.code
                }})
              </span>
            </div>
          </div>

          <!-- Differential -->
          <div class="row g-0 border-bottom align-items-center" *ngIf="fieldConfigs['bid_differential_value']">
            <div class="col-lg-5 p-3 bg-light-blue fw-medium">{{ fieldConfigs['bid_differential_value']?.label ||
              'Differential' }}</div>
            <div class="col-lg-7 p-3">
              <div class="d-flex align-items-center">
                <span class="fw-bold text-primary me-2">{{ supplier.bid['exchanged_differential'] }}
                  {{baseCurrency.code}} / {{baseUnit.code}}</span>
                <ng-template #popConvD1Title>Original Differential</ng-template>
                <ng-template #popConvD1Content>
                  <p class="mb-0"><strong>{{supplier.bid.differential?.getLabel()}}</strong></p>
                </ng-template>
                <a href="javascript:void(0)"
                  *ngIf="isConverted($safeNavigationMigration(supplier.bid.differential?.price?.currency?.code), $safeNavigationMigration(supplier.bid.differential?.units?.code))"
                  [ngbPopover]="popConvD1Content" [popoverTitle]="popConvD1Title">
                  <i class="fas fa-sync-alt text-muted small" aria-hidden="true"></i>
                </a>
              </div>
            </div>
          </div>

          <!-- DFT -->
          <div class="row g-0 border-bottom align-items-center">
            <div class="col-lg-5 p-3 bg-light-blue fw-medium">
              DFT (Diff + Volume Fees)
              <ng-template #popDFTTitle>What is DFT?</ng-template>
              <ng-template #popDFTContent>Differential + volume based fees and taxes</ng-template>
              <a href="javascript:void(0)" [ngbPopover]="popDFTContent" [popoverTitle]="popDFTTitle"><i
                  class="fas fa-info-circle mx-1 text-muted" aria-hidden="true"></i></a>
            </div>
            <div class="col-lg-7 p-3">
              <span class="fs-5 fw-bold">{{ supplier.bid['diff_plus_vbfees'] | number: '1.'}} {{baseCurrency.code}} /
                {{baseUnit.code}}</span>
            </div>
          </div>

          <!-- DFTC -->
          <div class="row g-0 border-bottom align-items-center">
            <div class="col-lg-5 p-3 bg-light-blue fw-medium">
              DFTC (DFT + Credit Terms)
              <ng-template #popTitle>What is DFTC?</ng-template>
              <ng-template #popContent>Differential + volume based fees and taxes + comparative payment
                terms</ng-template>
              <a href="javascript:void(0)" [ngbPopover]="popContent" [popoverTitle]="popTitle"><i
                  class="fas fa-info-circle mx-1 text-muted" aria-hidden="true"></i></a>
            </div>
            <div class="col-lg-7 p-3">
              <span class="fs-5 fw-bold text-success">{{ supplier.costOfPaymentTerms + supplier.bid['diff_plus_vbfees']
                | number: '1.'}} {{baseCurrency.code}} / {{baseUnit.code}}</span>
              <div class="small text-muted mt-1" *ngIf="supplier.bid.dftc && supplier.bid.dftc.price">
                Cost of Payment Terms: {{ supplier.costOfPaymentTerms }} {{ supplier.bid.dftc.price.currency.code }} /
                {{contract.units.code}}
              </div>
            </div>
          </div>

          <!-- Volume Fees -->
          <div class="row g-0 border-bottom align-items-start" *ngIf="fieldConfigs['bid_fee_1_name']">
            <div class="col-lg-5 p-3 bg-light-blue fw-medium">{{ fieldConfigs['bid_fee_1_name']?.label || 'Volume Based
              Fees & Taxes' }}</div>
            <div class="col-lg-7 p-3">
              <div *ngFor="let volumeFee of supplier.bid['exchanged_volume_based_fees']; let index = index;"
                class="mb-1 d-flex justify-content-between">
                <span>{{volumeFee.name}}: <strong>{{volumeFee.value}} {{baseCurrency.code}} /
                    {{baseUnit.code}}</strong></span>
                <ng-template #popConv3Title>Original Fee</ng-template>
                <ng-template #popConv3Content>
                  <span>{{volumeFee['original']['value']}} {{volumeFee['original']['currency']}}/
                    {{volumeFee['original']['unit']}}</span>
                </ng-template>
                <a href="javascript:void(0)"
                  *ngIf="isConverted(volumeFee['original']['currency'], volumeFee['original']['unit'])"
                  [ngbPopover]="popConv3Content" [popoverTitle]="popConv3Title" class="ms-2">
                  <i class="fas fa-sync-alt text-muted small" aria-hidden="true"></i>
                </a>
              </div>
              <div *ngFor="let volumeFee of supplier.bid.volumeFeesPercent; let index = index;"
                class="text-muted small">
                {{volumeFee.percent}}% <span *ngIf="volumeFee.based_fee">{{volumeFee.based_fee.name}}</span>
              </div>
              <span
                *ngIf="!supplier.bid['exchanged_volume_based_fees']?.length && !supplier.bid.volumeFeesPercent?.length"
                class="text-muted small italic">None</span>
            </div>
          </div>

          <!-- Per Usage Fees -->
          <div class="row g-0 align-items-start" *ngIf="fieldConfigs['bid_non_mandatory_fees']">
            <div class="col-lg-5 p-3 bg-light-blue fw-medium">{{ fieldConfigs['bid_non_mandatory_fees']?.label || 'Per
              Usage Based Fees' }}</div>
            <div class="col-lg-7 p-3">
              <div *ngFor="let perUsageFee of supplier.bid['exchanged_per_fees']"
                class="mb-1 d-flex justify-content-between">
                <span>{{perUsageFee.name}}: <strong>{{perUsageFee.value}} {{baseCurrency.code}}</strong></span>
                <ng-template #popConvD5Title>Original Input</ng-template>
                <ng-template #popConvD5Content>
                  <span>{{perUsageFee['original']['value']}} {{perUsageFee['original']['currency']}}</span>
                </ng-template>
                <a href="javascript:void(0)"
                  *ngIf="isConverted(perUsageFee['original']['currency'])"
                  [ngbPopover]="popConvD5Content" [popoverTitle]="popConvD5Title"
                  class="ms-2">
                  <i class="fas fa-sync-alt text-muted small" aria-hidden="true"></i>
                </a>
              </div>
              <span *ngIf="!supplier.bid['exchanged_per_fees']?.length" class="text-muted small italic">None</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Operational Details Card -->
      <div class="card card-custom mb-4"
        *ngIf="[offerStatuses.RECEIVED, offerStatuses.AWARDED, offerStatuses.DECLINED_SUBMITTED].includes(supplier.status)">
        <div class="card-header bg-light py-3">
          <h5 class="mb-0">Operational Details</h5>
        </div>
        <div class="card-body p-0">
          <!-- Delivery Point -->
          <div class="row g-0 border-bottom align-items-center" *ngIf="fieldConfigs['bid_delivery_point']">
            <div class="col-lg-5 p-3 bg-light-blue fw-medium">{{ fieldConfigs['bid_delivery_point']?.label || 'Delivery
              Point' }}</div>
            <div class="col-lg-7 p-3">
              {{ resolveFieldValue(fieldConfigs['bid_delivery_point']) }}
            </div>
          </div>

          <!-- Billing Type -->
          <div class="row g-0 border-bottom align-items-center" *ngIf="fieldConfigs['bid_gross_or_net_billing']">
            <div class="col-lg-5 p-3 bg-light-blue fw-medium">{{ fieldConfigs['bid_gross_or_net_billing']?.label ||
              'Billing Type' }}</div>
            <div class="col-lg-7 p-3">
              {{ resolveFieldValue(fieldConfigs['bid_gross_or_net_billing']) }}
            </div>
          </div>

          <!-- Into-plane Agent -->
          <div class="row g-0 border-bottom align-items-center" *ngIf="fieldConfigs['bid_into_plane_service_provider']">
            <div class="col-lg-5 p-3 bg-light-blue fw-medium">{{ fieldConfigs['bid_into_plane_service_provider']?.label
              || 'Into-plane Agent' }}</div>
            <div class="col-lg-7 p-3">
              {{ supplier.bid.intoPlaneServiceProvider?.name || '-' }}
            </div>
          </div>

          <!-- Airport Delivery -->
          <div class="row g-0 border-bottom align-items-start" *ngIf="fieldConfigs['bid_delivery_method_to_airport_1']">
            <div class="col-lg-5 p-3 bg-light-blue fw-medium">{{ fieldConfigs['bid_delivery_method_to_airport_1']?.label
              || 'Delivery to Airport' }}</div>
            <div class="col-lg-7 p-3">
              <div *ngFor="let airPortDelivery of supplier.bid.airPortDeliveryMethods; let i = index" class="mb-1">
                <ng-container *ngIf="i < 4">
                  {{airPortDelivery.method?.name}}<span *ngIf="airPortDelivery.percentage">
                    <strong>{{airPortDelivery.percentage}}%</strong></span>
                </ng-container>
              </div>
              <span *ngIf="!supplier.bid.airPortDeliveryMethods?.length" class="text-muted small italic">None</span>
            </div>
          </div>

          <!-- Aircraft Delivery -->
          <div class="row g-0 border-bottom align-items-center" *ngIf="fieldConfigs['bid_aircraft_delivery_method']">
            <div class="col-lg-5 p-3 bg-light-blue fw-medium">{{ fieldConfigs['bid_aircraft_delivery_method']?.label ||
              'Delivery to Aircraft' }}</div>
            <div class="col-lg-7 p-3">
              {{ supplier.bid.airCraftDeliveryMethod?.name || '-' }}
            </div>
          </div>

          <!-- Open Fuel Release -->
          <div class="row g-0 border-bottom align-items-center" *ngIf="fieldConfigs['bid_open_fuel_release']">
            <div class="col-lg-5 p-3 bg-light-blue fw-medium">{{ fieldConfigs['bid_open_fuel_release']?.label }}</div>
            <div class="col-lg-7 p-3">
              {{ resolveFieldValue(fieldConfigs['bid_open_fuel_release']) }}
            </div>
          </div>

          <!-- Operational History Constraint Fields (Notification & Limitations) -->
          <div class="row g-0 border-bottom align-items-start"
            *ngIf="fieldConfigs['bid_pre_flight_notification_hours'] || fieldConfigs['bid_ramp_limitations_notes']">
            <div class="col-lg-5 p-3 bg-light-blue fw-medium">Operational Constraints</div>
            <div class="col-lg-7 p-3">
              <div class="mb-2" *ngIf="fieldConfigs['bid_pre_flight_notification_hours']">
                <span class="text-muted small d-block">{{ fieldConfigs['bid_pre_flight_notification_hours']?.label
                  }}:</span>
                <jft-read-more-modal [title]="$safeNavigationMigration(fieldConfigs['bid_pre_flight_notification_hours']?.label)"
                  [text]="$safeNavigationMigration(supplier.bid.preFlightNotification?.getLabel())"></jft-read-more-modal>
              </div>
              <div class="mb-2" *ngIf="fieldConfigs['bid_ramp_limitations_notes']">
                <span class="text-muted small d-block">{{ fieldConfigs['bid_ramp_limitations_notes']?.label }}:</span>
                <jft-read-more-modal [title]="$safeNavigationMigration(fieldConfigs['bid_ramp_limitations_notes']?.label)"
                  [text]="$safeNavigationMigration(supplier.bid.rampLimitations?.getLabel())"></jft-read-more-modal>
              </div>
              <div class="mb-0" *ngIf="fieldConfigs['bid_fuel_availability_notes']">
                <span class="text-muted small d-block">{{ fieldConfigs['bid_fuel_availability_notes']?.label }}:</span>
                <jft-read-more-modal [title]="$safeNavigationMigration(fieldConfigs['bid_fuel_availability_notes']?.label)"
                  [text]="$safeNavigationMigration(supplier.bid.fuelAvailability?.getLabel())"></jft-read-more-modal>
              </div>
            </div>
          </div>

          <!-- Contract Terms & Feedback -->
          <div class="row g-0 align-items-start">
            <div class="col-lg-5 p-3 bg-light-blue fw-medium">Contract Terms & Feedback</div>
            <div class="col-lg-7 p-3">
              <div class="mb-2"
                *ngIf="fieldConfigs['location_contract_start_date'] && supplier.bid.date_contract_start && supplier.bid.date_contract_end">
                <span class="text-muted small d-block">{{ fieldConfigs['location_contract_start_date']?.label ||
                  'Contract Period' }}:</span>
                <span class="fw-bold">{{ supplier.bid.date_contract_start.toDate() | date: defaultDateFormat : 'utc'}} -
                  {{ supplier.bid.date_contract_end.toDate() | date: defaultDateFormat : 'utc'}}</span>
              </div>
              <!-- Bid Notes -->
              <div class="mb-2" *ngIf="fieldConfigs['bid_notes'] && supplier.bid.note">
                <span class="text-muted small d-block">{{ fieldConfigs['bid_notes']?.label || 'Bid Notes' }}:</span>
                <jft-read-more-modal [title]="fieldConfigs['bid_notes']?.label || 'Bid Notes'"
                  [text]="supplier.bid.note"></jft-read-more-modal>
              </div>
              <!-- Supply Conditions Comments -->
              <div class="mb-0"
                *ngIf="fieldConfigs['bid_supply_conditions_comments'] && (supplier.bid.supplyCondition?.notes || supplier.bid.comments)">
                <span class="text-muted small d-block">{{ fieldConfigs['bid_supply_conditions_comments']?.label ||
                  'Supply Conditions Comments' }}:</span>
                <jft-read-more-modal
                  [title]="fieldConfigs['bid_supply_conditions_comments']?.label || 'Supply Conditions Comments'"
                  [text]="supplier.bid.supplyCondition?.notes || supplier.bid.comments"></jft-read-more-modal>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Payment Terms Card -->
      <div class="card card-custom mb-4"
        *ngIf="[offerStatuses.RECEIVED, offerStatuses.AWARDED, offerStatuses.DECLINED_SUBMITTED].includes(supplier.status)">
        <div class="card-header bg-light py-3">
          <h5 class="mb-0">Payment Terms & Financials</h5>
        </div>
        <div class="card-body p-0">
          <!-- Payment Type & Terms -->
          <div class="row g-0 border-bottom align-items-start">
            <div class="col-lg-5 p-3 bg-light-blue fw-medium">Payment Method & Terms</div>
            <div class="col-lg-7 p-3">
              <div class="mb-3" *ngIf="fieldConfigs['bid_payment_type']">
                <span class="text-muted small d-block">{{ fieldConfigs['bid_payment_type']?.label }}:</span>
                <span class="fw-bold">{{ supplier.bid.isPaymentOpenInvoice() ? 'Open Invoice' : 'Prepayment' }}</span>
              </div>

              <!-- Open Invoice Details -->
              <ng-container *ngIf="supplier.bid.isPaymentOpenInvoice()">
                <div class="row">
                  <div class="col-6 mb-2" *ngIf="fieldConfigs['bid_open_invoice_payment_terms']">
                    <span class="text-muted small d-block">{{ fieldConfigs['bid_open_invoice_payment_terms']?.label
                      }}:</span>
                    <span>{{ resolveFieldValue(fieldConfigs['bid_open_invoice_payment_terms']) }}</span>
                  </div>
                  <div class="col-6 mb-2" *ngIf="fieldConfigs['bid_open_invoice_payment_reference_date']">
                    <span class="text-muted small d-block">{{
                      fieldConfigs['bid_open_invoice_payment_reference_date']?.label }}:</span>
                    <span>{{ resolveFieldValue(fieldConfigs['bid_open_invoice_payment_reference_date']) }}</span>
                  </div>
                  <div class="col-6 mb-2" *ngIf="fieldConfigs['bid_open_invoice_invoice_frequency']">
                    <span class="text-muted small d-block">{{ fieldConfigs['bid_open_invoice_invoice_frequency']?.label
                      }}:</span>
                    <span>{{ resolveFieldValue(fieldConfigs['bid_open_invoice_invoice_frequency']) }}</span>
                  </div>
                  <div class="col-6 mb-2" *ngIf="fieldConfigs['bid_invoice_type']">
                    <span class="text-muted small d-block">{{ fieldConfigs['bid_invoice_type']?.label }}:</span>
                    <span>{{ resolveFieldValue(fieldConfigs['bid_invoice_type']) }}</span>
                  </div>
                </div>
              </ng-container>

              <!-- Prepayment Details -->
              <ng-container *ngIf="supplier.bid.isPaymentPrepayment()">
                <div class="row">
                  <div class="col-6 mb-2" *ngIf="fieldConfigs['bid_prepayment_number_of_days_prepaid']">
                    <span class="text-muted small d-block">{{
                      fieldConfigs['bid_prepayment_number_of_days_prepaid']?.label }}:</span>
                    <span>{{ resolveFieldValue(fieldConfigs['bid_prepayment_number_of_days_prepaid']) }}</span>
                  </div>
                  <div class="col-6 mb-2" *ngIf="fieldConfigs['bid_prepayment_payment_first_delivery']">
                    <span class="text-muted small d-block">{{
                      fieldConfigs['bid_prepayment_payment_first_delivery']?.label }}:</span>
                    <span>{{ resolveFieldValue(fieldConfigs['bid_prepayment_payment_first_delivery']) }}</span>
                  </div>
                  <div class="col-6 mb-2" *ngIf="fieldConfigs['bid_prepayment_payment_frequency']">
                    <span class="text-muted small d-block">{{ fieldConfigs['bid_prepayment_payment_frequency']?.label
                      }}:</span>
                    <span>{{ resolveFieldValue(fieldConfigs['bid_prepayment_payment_frequency']) }}</span>
                  </div>
                  <div class="col-6 mb-2" *ngIf="fieldConfigs['bid_prepayment_amount']">
                    <span class="text-muted small d-block">{{ fieldConfigs['bid_prepayment_amount']?.label }}:</span>
                    <span>{{ resolveFieldValue(fieldConfigs['bid_prepayment_amount']) }}</span>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>

          <!-- Financial Details -->
          <div class="row g-0 border-bottom align-items-start">
            <div class="col-lg-5 p-3 bg-light-blue fw-medium">Financial Configuration</div>
            <div class="col-lg-7 p-3">
              <div class="row">
                <div class="col-6 mb-2" *ngIf="fieldConfigs['bid_payment_currency']">
                  <span class="text-muted small d-block">{{ fieldConfigs['bid_payment_currency']?.label }}:</span>
                  <span>{{ resolveFieldValue(fieldConfigs['bid_payment_currency']) }}</span>
                </div>
                <div class="col-6 mb-2" *ngIf="fieldConfigs['bid_payment_unit']">
                  <span class="text-muted small d-block">{{ fieldConfigs['bid_payment_unit']?.label }}:</span>
                  <span>{{ resolveFieldValue(fieldConfigs['bid_payment_unit']) }}</span>
                </div>
                <div class="col-6 mb-2" *ngIf="fieldConfigs['bid_method_of_payment']">
                  <span class="text-muted small d-block">{{ fieldConfigs['bid_method_of_payment']?.label }}:</span>
                  <span>{{ resolveFieldValue(fieldConfigs['bid_method_of_payment']) }}</span>
                </div>
                <div class="col-6 mb-2" *ngIf="fieldConfigs['bid_payment_exchange_financial_source']">
                  <span class="text-muted small d-block">{{ fieldConfigs['bid_payment_exchange_financial_source']?.label
                    }}:</span>
                  <span>{{ resolveFieldValue(fieldConfigs['bid_payment_exchange_financial_source']) }}</span>
                </div>
                <div class="col-6 mb-2" *ngIf="fieldConfigs['bid_payment_averaging_method']">
                  <span class="text-muted small d-block">{{ fieldConfigs['bid_payment_averaging_method']?.label
                    }}:</span>
                  <span>{{ resolveFieldValue(fieldConfigs['bid_payment_averaging_method']) }}</span>
                </div>
                <div class="col-6 mb-2" *ngIf="fieldConfigs['bid_payment_averaging_offset']">
                  <span class="text-muted small d-block">{{ fieldConfigs['bid_payment_averaging_offset']?.label
                    }}:</span>
                  <span>{{ resolveFieldValue(fieldConfigs['bid_payment_averaging_offset']) }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Guarantees & Deposits -->
          <div class="row g-0 align-items-start">
            <div class="col-lg-5 p-3 bg-light-blue fw-medium">Guarantees & Deposits</div>
            <div class="col-lg-7 p-3">
              <div class="mb-2" *ngIf="fieldConfigs['bid_guarantees_deposits_required']">
                <span class="text-muted small d-block">{{ fieldConfigs['bid_guarantees_deposits_required']?.label
                  }}:</span>
                <span>{{ resolveFieldValue(fieldConfigs['bid_guarantees_deposits_required']) }}</span>
              </div>
              <div class="row" *ngIf="supplier.bid.bankGuaranteeAmount">
                <div class="col-6 mb-2" *ngIf="fieldConfigs['bid_bank_guarantee_amount']">
                  <span class="text-muted small d-block">{{ fieldConfigs['bid_bank_guarantee_amount']?.label }}:</span>
                  <span class="fw-bold">{{ supplier.bid.bankGuaranteeAmount | number:'1.2-2' }}</span>
                </div>
                <div class="col-6 mb-2" *ngIf="fieldConfigs['bid_bank_guarantee_currency']">
                  <span class="text-muted small d-block">{{ fieldConfigs['bid_bank_guarantee_currency']?.label
                    }}:</span>
                  <span>{{ currencies.getById(supplier.bid.bankGuaranteeCurrency)?.code }}</span>
                </div>
              </div>
              <div class="row" *ngIf="supplier.bid.transitTime != null">
                <div class="col-6 mb-2" *ngIf="fieldConfigs['bid_transit_time']">
                  <span class="text-muted small d-block">{{ fieldConfigs['bid_transit_time']?.label || 'Transit Time (Days)' }}:</span>
                  <span class="fw-bold">{{ supplier.bid.transitTime }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- SAF Information Card -->
      <div class="card mb-4 border-0 shadow-sm"
        *ngIf="fieldConfigs['bid_saf_mandate'] || fieldConfigs['bid_saf_mandate_blend'] || fieldConfigs['bid_neat_saf_mandated_price']">
        <div class="card-header bg-white border-bottom-0 py-3">
          <h5 class="card-title mb-0 d-flex align-items-center">
            <i class="fas fa-leaf text-success me-2"></i>
            Sustainable Aviation Fuel (SAF)
          </h5>
        </div>
        <div class="card-body p-0">
          <div class="row g-0 border-bottom align-items-center" *ngIf="fieldConfigs['bid_saf_mandate']">
            <div class="col-lg-5 p-3 bg-light-blue fw-medium">{{ fieldConfigs['bid_saf_mandate']?.label }}</div>
            <div class="col-lg-7 p-3">{{ resolveFieldValue(fieldConfigs['bid_saf_mandate']) }}</div>
          </div>
          <div class="row g-0 border-bottom align-items-center" *ngIf="fieldConfigs['bid_saf_mandate_blend']">
            <div class="col-lg-5 p-3 bg-light-blue fw-medium">{{ fieldConfigs['bid_saf_mandate_blend']?.label }}</div>
            <div class="col-lg-7 p-3">{{ resolveFieldValue(fieldConfigs['bid_saf_mandate_blend']) }}%</div>
          </div>
          <div class="row g-0 border-bottom align-items-center" *ngIf="fieldConfigs['bid_neat_saf_mandated_price']">
            <div class="col-lg-5 p-3 bg-light-blue fw-medium">{{ fieldConfigs['bid_neat_saf_mandated_price']?.label }}
            </div>
            <div class="col-lg-7 p-3">
              {{ resolveFieldValue(fieldConfigs['bid_neat_saf_mandated_price']) }}
              <span *ngIf="supplier.bid.neatSaf">
                {{ supplier.bid.neatSaf.price?.currency?.code }} /
                {{ supplier.bid.neatSaf.price?.units?.code }}
              </span>
            </div>
          </div>
          <div class="row g-0 border-bottom align-items-center" *ngIf="fieldConfigs['bid_neat_saf_volume']">
            <div class="col-lg-5 p-3 bg-light-blue fw-medium">{{ fieldConfigs['bid_neat_saf_volume']?.label }}</div>
            <div class="col-lg-7 p-3">{{ resolveFieldValue(fieldConfigs['bid_neat_saf_volume']) }}</div>
          </div>
          <div class="row g-0 border-bottom align-items-center" *ngIf="fieldConfigs['bid_saf_fee_amount']">
            <div class="col-lg-5 p-3 bg-light-blue fw-medium">{{ fieldConfigs['bid_saf_fee_amount']?.label }}</div>
            <div class="col-lg-7 p-3">
              {{ resolveFieldValue(fieldConfigs['bid_saf_fee_amount']) }}
              <span *ngIf="supplier.bid.safFeeAmountUnits">
                {{ supplier.bid.safFeeAmountUnits.price?.currency?.code }} /
                {{ supplier.bid.safFeeAmountUnits.price?.units?.code }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Additional Information Card -->
      <div class="card card-custom mb-4"
        *ngIf="[offerStatuses.RECEIVED, offerStatuses.AWARDED, offerStatuses.DECLINED_SUBMITTED].includes(supplier.status)">
        <div class="card-header bg-light py-3">
          <h5 class="mb-0">Additional Information</h5>
        </div>
        <div class="card-body p-0">
          <div class="row g-0 border-bottom align-items-center" *ngIf="fieldConfigs['bid_iata_service_level']">
            <div class="col-lg-5 p-3 bg-light-blue fw-medium">{{ fieldConfigs['bid_iata_service_level']?.label }}</div>
            <div class="col-lg-7 p-3">{{ resolveFieldValue(fieldConfigs['bid_iata_service_level']) }}</div>
          </div>

          <div class="row g-0 border-bottom align-items-center"
            *ngIf="fieldConfigs['bid_fuel_availability_percentage']">
            <div class="col-lg-5 p-3 bg-light-blue fw-medium">{{ fieldConfigs['bid_fuel_availability_percentage']?.label
              }}</div>
            <div class="col-lg-7 p-3">{{ resolveFieldValue(fieldConfigs['bid_fuel_availability_percentage']) }}%</div>
          </div>

          <!-- Dynamic Fields (only show fields with values) -->
          <ng-container *ngFor="let field of dynamicFields">
            <div class="row g-0 border-bottom align-items-center" *ngIf="resolveFieldValue(field) !== '-'">
              <div class="col-lg-5 p-3 bg-light-blue fw-medium">{{ field.label }}</div>
              <div class="col-lg-7 p-3">{{ resolveFieldValue(field) }}</div>
            </div>
          </ng-container>

          <!-- Signature -->
          <div class="row g-0 border-top mt-2" *ngIf="supplier.bid.signature">
            <div class="col-lg-12 p-3">
              <div class="text-muted small text-uppercase fw-bold mb-2">Supplier Signature:</div>
              <div class="signature-preview border rounded p-2 bg-white" style="max-width: 300px;">
                <img [src]="supplier.bid.signature | secureImage" class="img-fluid" alt="Signature" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Awaiting / Declined Card -->
      <div class="card card-custom mb-4" *ngIf="!supplier.bid">
        <div class="card-body p-4 text-center">
          <div class="mb-3">
            <i class="fas fa-clock fa-3x text-muted"></i>
          </div>
          <h5 *ngIf="awaitingOfferStatuses.includes(supplier.status)" class="mb-2">Awaiting offer from {{
            supplier.supplier.name }}</h5>
          <h5 *ngIf="[offerStatuses.DECLINED].includes(supplier.status)" class="mb-2">{{ supplier.supplier.name }} will
            not be submitting a bid at this location</h5>
          <p class="text-muted mb-0" *ngIf="awaitingOfferStatuses.includes(supplier.status)">The supplier has not
            submitted their bid yet. You will be notified once it is received.</p>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-4">
      <div class="card bg-white mb-4 border-0 shadow-sm chat">
        <jft-tender-chat [tender]="tender" [contract]="contract" [destinationCompany]="supplier.supplier">
        </jft-tender-chat>
      </div>

      <div class="card bg-white mb-4 border-0 shadow-sm">
        <h4 class="card-header bg-white d-flex align-items-center min-height">
          Shared Files <small><jft-count [objects]="getAllDocuments()" [initCount]="0"></jft-count></small>
        </h4>
        <ul class="list-group list-group-flush">
          <li *ngIf="!documents.length && !coverLetter.file && !supplierRequestedDocuments.length"
            class="list-group-item  d-flex align-items-center min-height text-muted">No files to display</li>
          <li class="list-group-item  d-flex align-items-center min-height"
            *ngIf="documents.length || coverLetter.file">
            <div class="text-muted fw-bold">
              Files Uploaded by Airline
            </div>
          </li>
          <document-condensed-list *ngIf="coverLetter && coverLetter.file"
            (documentUpdated)="updateDocumentsEvent($event)" [documents]="[coverLetter.file]" [readonly]="!user.canManage(tender)"
            [tenderId]="tender.id" [class]="'border-bottom'">
          </document-condensed-list>
          <document-condensed-list *ngIf="documents.length" (documentUpdated)="updateDocumentsEvent($event)"
            [documents]="documents" [tenderId]="tender.id" [readonly]="!user.canManage(tender)">
          </document-condensed-list>
          <li class="list-group-item  d-flex align-items-center min-height" *ngIf="supplierRequestedDocuments.length">
            <div class="text-muted fw-bold">
              Files Uploaded by Supplier
            </div>
          </li>
          <document-condensed-list (documentUpdated)="updateDocumentsEvent($event)"
            [documents]="supplierRequestedDocuments" [tenderId]="tender.id" [readonly]="true">
          </document-condensed-list>
          <li *ngIf="user.canManage(tender)" class="list-group-item  d-flex align-items-center min-height">
            <label for="add-doc">
              <a class="text-dark pointer"><i class="fas fa-plus me-2" aria-hidden="true"></i>Upload Document</a>
            </label>
            <input id="add-doc" class="d-none" (change)="addDocumentFile($event)" type="file">
          </li>
        </ul>
      </div>

      <div class="card bg-white border-0 shadow-sm notes">
        <jft-tender-note [tender]="tender" [contract]="contract" [supplierId]="supplier.supplier.id"
          [offer]="supplier"></jft-tender-note>
      </div>
    </div>
  </div>
</div>